import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseTask } from '../../types/advise';
import { getAdviseAccountId, withAdviseAccountIds } from './helpers';

export const fetchAdviseTasks = async (engagementId?: string): Promise<CallResult<AdviseTask[]>> =>
  withAdviseAccountIds('tasks', (accountIds) => {
    const params = new URLSearchParams();
    params.set('account_ids', accountIds.join(','));
    if (engagementId) params.set('engagement_id', engagementId);
    return callExternalApi<AdviseTask[]>({
      url: `api/advise/tasks?${params.toString()}`,
      method: 'GET',
      headers: { 'content-type': 'application/json' }
    });
  });

export const createAdviseTask = async (task: Partial<AdviseTask>): Promise<CallResult<AdviseTask>> => {
  const accountId = getAdviseAccountId();
  return callExternalApi<AdviseTask>({
    url: 'api/advise/tasks',
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: { ...task, account_id: accountId }
  });
};

export const updateAdviseTask = async (id: string, task: Partial<AdviseTask>): Promise<CallResult<AdviseTask>> => {
  return callExternalApi<AdviseTask>({
    url: `api/advise/tasks/${id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: task
  });
};

export const deleteAdviseTask = async (id: string): Promise<CallResult<void>> => {
  return callExternalApi<void>({
    url: `api/advise/tasks/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
